import React from "react";

function Cart(props) {
    return (
        <div>
            <div className="container">
                <div class="row">
                    <h3>Shopping Cart</h3>
                    <hr class="under-title" />
                </div>
                <div class="row">
                    <div class="col-sm-7">
                        <img src="assets/images/14.jpg" />
                    </div>
                    <div class="col-sm-5">
                        <h3>
                            ONLINE <span>SHOP</span>
                        </h3>
                        <p>
                            If you would like to experience the best of online shopping for men, women and kids in India, you are at the right place. Online Shop is the ultimate destination for fashion and lifestyle, being host to a wide array of merchandise including clothing, footwear, accessories, jewellery, personal care products and more. It is time to redefine your style statement with our treasure-trove of trendy items.
            </p>
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-sm-12">
                        <p>
                            Our online store brings you the latest in designer products straight out of fashion houses.Becoming India’s no. 1 fashion destination is not an easy feat. Sincere efforts, digital enhancements and a team of dedicated personnel with an equally loyal customer base have made Online Shop the online platform that it is today. The original B2B venture for personalized gifts was conceived in 2007 but transitioned into a full-fledged ecommerce giant within a span of just a few years. By 2012, Online Shop had introduced 350 Indian and international brands to its platform, and this has only grown in number each passing year. Today Online Shop sits on top of the online fashion game with an astounding social media following, a loyalty program dedicated to its customers, and tempting, hard-to-say-no-to deals.
              <br /><br />
              The Online Shop shopping app came into existence in the year 2015 to further encourage customers’ shopping sprees. Download the app on your Android or IOS device this very minute to experience fashion like never before
            </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cart;